export const ProdutionBase = true;

const Holidays = [
   '2026-01-15', // Thursday, Municipal Corporation Election - Maharashtra
   '2026-01-26', // Monday, Republic Day
   '2026-03-03', // Tuesday, Holi
   '2026-03-26', // Thursday,	Shri Ram Navami
   '2026-03-31', // Tuesday, Shri Mahavir Jayanti
   '2026-04-03', // Friday, Good Friday
   '2026-04-14', // Tuesday, Dr. Baba Saheb Ambedkar Jayanti
   '2026-05-01', // Friday, Maharashtra Day
   '2026-05-28', // Thursday,	Bakri Id
   '2026-06-26', // Friday, Muharram
   '2026-09-14', // Monday, Ganesh Chaturthi
   '2026-10-02', // Friday, Mahatma Gandhi Jayanti
   '2026-10-20', // Tuesday, Dussehra
   '2026-11-10', // Tuesday, Diwali-Balipratipada
   '2026-11-24', // Tuesday, Prakash Gurpurb Sri Guru Nanak Dev
   '2026-12-25', // Friday, Christmas
  ];

  const SpecialdateOpen = [
    '2026-02-01', // Union Budget

  ]

    const today = new Date();
    const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
    const currentDate = today.toISOString().split("T")[0];
    const currentTime = `${String(today.getHours()).padStart(2, "0")}:${String(today.getMinutes()).padStart(2, "0")}`;
    let startTime = "09:07";
    let endTime = "21:29";

    let Current_date;

    if (((currentDay >= 1 && currentDay <= 5) || SpecialdateOpen.includes(currentDate)) && !Holidays.includes(currentDate) && currentTime >= startTime && currentTime <= endTime) {
      Current_date = currentDate;      

    } else {
      // Non-trading days and hours logic
      let days = 1;
      if (currentDay === 1) {
        // Monday
        days = 3;
      } else if (currentDay === 6) {
        // Saturday/Hodliday
        days = 1; // Sat/Holiday:- 1, Fri Holiday & Next Sat:- 2
      } else if (currentDay === 0) {
        // Sunday 2, Sunday and Friday was Holday 3
        days = 2;
      }

      
      if ((currentDay >= 1 && currentDay <= 6) && (currentTime >= "21:30" &&  currentTime <= "23:59")) {
        // console.log(">>>>>>>>>>", new Date())
        Current_date = new Date();
      }else{
        // console.log(">>>>", endTime, currentDay)
        Current_date = new Date(today.setDate(today.getDate() - days));
      }
      
      // console.log("ddddddddddddddddddddddd", endTime, currentDay, days, Current_date);
    }
    
export const NSE_Current_date = Current_date;
export const NSE_filter_volume = 200000;
export const NSE_filter_marketcap = 1000;


export const methodList = ["Default", "Deg", "Breakout", "Spikes", "Signal7", "WOI", "Consecutive", "Engulf", "Delivery", "Symbol", "Monthly Swing", "Bulk", "OL", "HotStar", "NR7", "Golden Cross", "Golden Stocks", "TurnOver"];
export const dematNameList = ["Dhan", "Zerodha", "Angle", "Groww"];
export const dematAmountList = [{"Demat":"Dhan", "Amount": 255732}, {"Demat":"Zerodha", "Amount":701486}, {"Demat":"Angle", "Amount":174835}, {"Demat":"Groww", "Amount":48700}];


// export const degAngle = (oldPrice, newPrice) => {
//   if (!oldPrice || oldPrice <= 0) return 0;
//   const changePercent = ((newPrice - oldPrice) / oldPrice) * 100;
//   const radians = Math.atan(changePercent / 100);
//   const degree = (radians * 180) / Math.PI;
//   return `${Number(degree.toFixed(2))}`;
// }


// For tody market duration 9:15AM to 21:00PM
export const todayMarketHoldTime = () =>{
    const currentTime = new Date();
    const startTime = new Date();
    startTime.setHours(9, 15, 0);
    
    const endTime = new Date();
    endTime.setHours(21, 0, 0); 

    if(currentTime >= startTime && currentTime <= endTime){
      return true;
    }else{
      return false;
    }
}

// Convert date to days
export const diffDays = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = end.getTime() - start.getTime(); // milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));  
  return diffDays;
};


// For convert days to years, months, and days
export const convertDaysApprox = (totalDays) =>{
  const days = Math.max(0, Math.floor(totalDays));
  const years = Math.floor(days / 365);
  const remAfterYears = days % 365;
  const months = Math.floor(remAfterYears / 30);
  const remDays = remAfterYears % 30;
  return `${years>0?  years + ' Yrs, ':''} ${months>0? months + ' Mths,':''}  ${remDays} Days`;
}

export const formatPercent = (value) => {
  const num = parseFloat(value.toString().replace('%', ''));
  return `${num.toFixed(2).padStart(5, '0')}`;
}

export function parseNumberString(s) {
  // Remove commas and any non-numeric chars except dot/minus
  if (s == null) return NaN;
  const cleaned = String(s).replace(/[^0-9.\-]/g, '');
  return cleaned === '' ? NaN : parseFloat(cleaned);
}

export const sortStockDataByDateDesc = (stockData = []) => {
  return [...stockData].sort(
    (a, b) => Date.parse(b.delivery_date) - Date.parse(a.delivery_date)
  );
};

export const isConsecutiveDay = (prevDate, currDate) => {
  const d1 = new Date(prevDate);
  const d2 = new Date(currDate);
  const diffDays = (d2 - d1) / (1000 * 60 * 60 * 24);

  return diffDays === 1 || diffDays === 2; // allow weekend gap
};

export const calculateLeaderScore = (stock) => {
    // ========================================
    //    Momentum
    //        ↓
    //    Structure / Slope   /  Confidence    
    //        ↓
    //    ADX / Trend strength
    //        ↓
    //    Volume + Delivery
    //        ↓
    //    RSI
    //        ↓
    //    ATR / Turnover
    // ===========================================

    const rsi = parseFloat(stock?.RSI || 0);
    const adx = parseFloat(stock?.ADX || 0);
    const atr = parseFloat(stock?.ATR_PER || 0);

    const angle5 = parseFloat(stock?.angle5 || 0);
    const angle10 = parseFloat(stock?.angle10 || 0);
    const angle15 = parseFloat(stock?.angle15 || 0);

    const delivery = parseFloat(stock?.delivery_per || 0);
    const prevDelivery = parseFloat(stock?.prev_delivery_per || 0);

    const volume = parseFloat(stock?.ttl_trd_qty || 0);
    const prevVolume = parseFloat(stock?.prev_volume || 0);

    const turnoverPer = parseFloat(stock?.Turnover_per || 0);

    let score = 0;


    // ==========================================
    // RSI (Max 18)
    // ==========================================

    if (rsi >= 65) {
        score += 18;
    } else if (rsi >= 60) {
        score += 15;
    } else if (rsi >= 55) {
        score += 12;
    } else if (rsi >= 50) {
        score += 9;
    } else if (rsi >= 45) {
        score += 5;
    }


    // ==========================================
    // ADX (Max 10)
    // ==========================================

    if (adx >= 40) {
        score += 10;
    } else if (adx >= 35) {
        score += 8;
    } else if (adx >= 30) {
        score += 6;
    } else if (adx >= 25) {
        score += 5;
    } else if (adx >= 20) {
        score += 3;
    } else if (adx >= 15) {
        score += 1;
    }


    // ==========================================
    // Momentum (Max 20)
    // ==========================================

    let acceleration =
        (angle5 * 0.5) +
        (angle10 * 0.3) +
        (angle15 * 0.2);

    acceleration = Math.max(
        Math.min(acceleration, 50),
        -50
    );

    let momentumScore = 0;

    if (acceleration >= 30) {
        momentumScore = 20;
    } else if (acceleration >= 20) {
        momentumScore = 17;
    } else if (acceleration >= 10) {
        momentumScore = 14;
    } else if (acceleration >= 5) {
        momentumScore = 10;
    } else if (acceleration > 0) {
        momentumScore = 5;
    }

    score += momentumScore;


    // ==========================================
    // Momentum Bonus (Max 3)
    // ==========================================

    if (
        angle5 > angle10 &&
        angle10 > angle15
    ) {
        score += 3;
    }


    // ==========================================
    // ATR (Max 5)
    // ==========================================

    score += Math.min(
        (atr / 10) * 5,
        5
    );


    // ==========================================
    // STRUCTURE
    // ==========================================

    let structureData = {};

    try {

        if (typeof stock?.structure_json === "string") {

            structureData =
                JSON.parse(stock.structure_json) || {};

        } else if (
            stock?.structure_json &&
            typeof stock.structure_json === "object"
        ) {

            structureData =
                stock.structure_json;

        }

    } catch (e) {

        structureData = {};

    }


    // ==========================================
    // Structure (Max 12)
    // ==========================================

    switch (structureData?.structure) {

        case "UPTREND":
            score += 12;
            break;

        case "EARLY_UPTREND":
            score += 10;
            break;

        case "BULLISH_CHOCH":
            score += 8;
            break;

        case "RANGE":
            score += 3;
            break;
    }


    const slope =
        parseFloat(structureData?.slope || 0);

    const confidence =
        parseFloat(structureData?.confidence || 0);


    // ==========================================
    // Slope (Max 6)
    // ==========================================

    if (slope >= 8) {
        score += 6;
    } else if (slope >= 6) {
        score += 5;
    } else if (slope >= 4) {
        score += 4;
    } else if (slope >= 2) {
        score += 3;
    } else if (slope >= 1) {
        score += 2;
    } else if (slope > 0) {
        score += 1;
    }


    // ==========================================
    // Confidence (Max 5)
    // ==========================================

    if (confidence >= 3) {
        score += 5;
    } else if (confidence >= 2.5) {
        score += 4;
    } else if (confidence >= 2) {
        score += 3;
    } else if (confidence >= 1.5) {
        score += 2;
    } else if (confidence >= 1) {
        score += 1;
    }


    // ==========================================
    // Trend Bonus (Max 2)
    // ==========================================

    if (
        structureData?.structure === "UPTREND" &&
        slope >= 4 &&
        confidence >= 1.5
    ) {
        score += 2;
    }


    // ==========================================
    // Delivery (Max 8)
    // ==========================================

    let deliveryScore = 0;

    const deliveryRatio =
        delivery / Math.max(prevDelivery, 1);


    if (delivery >= 55) {
        deliveryScore += 5;
    } else if (delivery >= 45) {
        deliveryScore += 4;
    } else if (delivery >= 35) {
        deliveryScore += 3;
    } else if (delivery >= 25) {
        deliveryScore += 2;
    }


    if (deliveryRatio >= 1.5) {
        deliveryScore += 3;
    } else if (deliveryRatio >= 1.2) {
        deliveryScore += 2;
    } else if (deliveryRatio >= 1.05) {
        deliveryScore += 1;
    }

    score += Math.min(deliveryScore, 8);


    // ==========================================
    // Volume (Max 8)
    // ==========================================

    const volumeRatio =
        volume / Math.max(prevVolume, 1);

    if (volumeRatio >= 2) {
        score += 8;
    } else if (volumeRatio >= 1.5) {
        score += 6;
    } else if (volumeRatio >= 1.2) {
        score += 3;
    }


    // ==========================================
    // Turnover (Max 3)
    // ==========================================

    if (turnoverPer >= 5) {
        score += 3;
    } else if (turnoverPer >= 4) {
        score += 2;
    } else if (turnoverPer >= 3) {
        score += 1;
    }


    // ==========================================
    // Final Score
    // ==========================================

    return Number(
        Math.min(score, 100).toFixed(2)
    );
};


export const getFairBuyPrice = ($stock) => {

    const defaultResponse = {
        buyPrice: 0,
        status: 'INVALID',
        emaDistance: 0
    };

    if (
        !$stock ||
        typeof $stock !== 'object' ||
        Object.keys($stock).length === 0
    ) {
        return defaultResponse;
    }

    const close = parseFloat($stock.close_price || 0);
    const ema20 = parseFloat($stock.EMA20 || 0);
    const atr = parseFloat($stock.ATR || 0);

    // console.log($stock, close, ema20, atr )

    if (!close || !ema20 || !atr) {
        return defaultResponse;
    }

    const emaDistance =
        ((close - ema20) / ema20) * 100;

    const atrPrice = +(close - atr).toFixed(2);
    const emaPrice = +(ema20 * 1.01).toFixed(2);

    let buyPrice = close;
    let status = 'BUYABLE';

    /*
     * BUYABLE
     * Price within 10% of EMA20
     */
    if (emaDistance <= 10) {

        status = 'BUYABLE';

        // choose nearest support
        buyPrice = Math.max(
            atrPrice,
            emaPrice
        );
    }

    /*
     * PULLBACK
     * Price 10%-15% above EMA20
     */
    else if (emaDistance <= 15) {

        status = 'PULLBACK';

        // deeper pullback expected
        buyPrice = Math.min(
            atrPrice,
            emaPrice
        );
    }

    /*
     * EXTENDED
     * Price >15% above EMA20
     */
    else {

        status = 'EXTENDED';

        // only buy near EMA20 zone
        buyPrice = emaPrice;
    }

    return {
        buyPrice: +buyPrice.toFixed(2),
        status,
        emaDistance: +emaDistance.toFixed(2)
    };
};

export const AIPromptForStockPL = (symbolName = '') => {
const prompt = `
LANGUAGE: Hindi

TODAY: ${new Date().toISOString().slice(0,10)}
Analyze NSE:${symbolName}

1. Chart Structure (Bullish / Neutral / Bearish)
2. YoY Sales Growth (%)
3. QoQ Sales Growth (%)
4. YoY Profit Growth (%)
5. QoQ Profit Growth (%)
6. Quarterly Trend (Improving / Stable / Weakening)
7. Overall Sales & Profit Growth Score (0-100%)

Calculate a combined score using:
- 30% YoY Sales Growth
- 20% QoQ Sales Growth
- 30% YoY Profit Growth
- 20% QoQ Profit Growth

Business Quality:
- Industry Growth
- Competitive Advantage (Moat)
- Future Growth Drivers
- Major Risks

Valuation:
- PE compared to Industry
- PEG Ratio
- Price vs Fair Value | show Fair Value price
- Overvalued / Fairly Valued / Undervalued


Calculate Overall Sales & Profit Score using this fixed formula:

Normalize each metric as follows:

>=50% growth = 100 points
30-49% = 80 points
20-29% = 70 points
10-19% = 60 points
0-9% = 50 points
Negative = 0 points

Overall Score = 30% YoY Sales Score + 20% QoQ Sales Score + 30% YoY Profit Score + 20% QoQ Profit Score
Return only the calculated score.


Display the result as:
Overall Sales & Profit Score:
🟢 85% (Strong Uptrend)
or
🟡 62% (Moderate Growth)
or
🔴 38% (Weak / Declining)

Also show:
• Overall Direction: ▲ Improving / ▼ Declining
• Key Reason (1-2 lines explaining the score)
`;

    return encodeURIComponent(prompt.trim());
}

export const AIPromptForStock1 = (symbolName = '') => {    
const prompt = `
LANGUAGE: Hindi

TODAY: ${new Date().toISOString().slice(0,10)}
Analyze NSE:${symbolName}

Check (TODAY):
Chart
YoY Sales growth (%),
Quarterly Sales growth (%),
YoY Profit growth (%),
Quarterly Profit growth (%),
Quarterly growth (%),
Overall Sales & Profit Growth Score (0-100%),
Quarterly Trend (Improving / Stable / Weakening),
Corporate Actions,
Latest Announcements,
Volume spike,
Delivery %,
FII/DII participation,
Big bull accumulation,
Promoter changes,
Bulk/block deals,

Order Book Analysis (TODAY):
Latest order book value,
Order inflow,
New contracts,
Order pipeline,
Execution visibility,
Order book / revenue ratio,

New contracts (TODAY and participation name):
Latest order book value,
New contracts,
Institutional buying,
Technical breakout.

Classify (TODAY):
Institutional accumulation,
Smart money,
Retail momentum,
Operator driven,
Sustainable or speculative rally.

Suggest:
Buy / Wait / Avoid,
Entry,
SL,
Target,
Risk Reward,
Confidence score,
Corporate Actions | Latest Announcements.
`;

    return encodeURIComponent(prompt.trim());
};

export const AIPromptForSector = () => {
    const prompt = `
Analyze Indian NSE sectors using ONLY latest publicly available data available TODAY.
Output in table format.

Sector Ranking Formula:
35% Institutional Participation
25% Relative Strength
20% Business Growth
10% Technical Breakout
10% Market Momentum

Sector Leading Performance:
1 Week
15 Days
1 Month
3 Month

For each show:
Sector Return %
Relative Strength
Momentum Change
Capacity Expansion
New Contracts
Supporting stocks

Institutional Participation in Sectors (with  New Contracts date):
FII sector allocation
DII sector allocation
Mutual fund flows
Bulk / block deals
Big bull accumulation
Capacity Expansion
New Contracts
Supporting stocks

For each show:
Previous %
Current %
Net Change

Output ONLY:

Top 5 CURRENT GROWING NSE sectors
(Rank 1-5)

For each show:
Rank
Sector
Institutional Score (1-10)
Business Score (1-10)
Technical Score (1-10)
Confidence %
Relative Strength
Supporting stocks

Top 5 UPCOMING NSE sectors (next 1-2 months)
(Rank 1-5)

For each show:
Rank
Sector
Institutional Score (1-10)
Business Score (1-10)
Technical Score (1-10)
Confidence %
Relative Strength
Supporting stocks

Stock Picks:

For each selected sector:
Top 5 stocks
Reason
Accumulation
Relative Strength
Supporting stocks

Final:
Current Leaders →
Upcoming Leaders →
Hidden Accumulation →
Avoid Sectors →
`;

    return encodeURIComponent(prompt.trim());
};


export const todayMarketSentiment = () =>{
const prompt = `
FIRST SECTION: Latest MARKET Bias UPDATE

Stock replacement allowed ONLY IF:
  New conviction > old conviction by 20 points
  Major news/event occurred
  Sector rotation changed materially

Global Markets Performance
- US Markets
- European Markets
- Asian Markets

Gift Nifty Indication

Crude Oil
Gold
USD/INR
Bond Yields

Major Global Events
Major Economic Events
Major Geopolitical Events

Stocks In News (Most Important)

Sector Rotation
   Top 5 strongest sectors
   Top 5 weakest sectors
   Emerging sectors under accumulation
   Sectors showing distribution

Trading Strategy For Tomorrow
   Best opportunities
   Sectors to focus on
   Sectors to avoid
   Expected market bias

For each stock provide:
- Stock Name
- Reason for News
- Positive / Negative / Neutral Impact
- Expected Impact Today
- Sector Impact

Include:
- Earnings Results
- Order Wins
- Large Contracts
- M&A Activity
- Promoter Buying/Selling
- Block Deals
- Bulk Deals
- Regulatory Actions
- Fund Raising
- Dividend Announcements
- Management Commentary
- Analyst Upgrades/Downgrades

`;
    return encodeURIComponent(prompt.trim());
}




export const recentOrder = () => {
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const formatDate = (date) => date.toISOString().slice(0, 10);
// TODAY: ${formatDate(today)}
// YESTERDAY: ${formatDate(yesterday)}

const prompt = `
TODAY: ${new Date().toISOString().slice(0,10)}

Search TODAY or YESTERDAY NSE/BSE corporate announcements.

Include only:
Order wins, LOAs, EPC, Govt, Defence, Railway, Power, Renewable, Infra, Export and Manufacturing contracts.

Rules:
- Use ONLY official NSE/BSE filings.
- Ignore news article dates.
- Filing date must be TODAY or YESTERDAY
- Exclude old, duplicate, re-announced or archived orders.
- Exclude board meetings, presentations, bonus, split, rumours, fund raising, unverified reports fundraising and MoUs.
- Market Cap > ₹1000 Cr.
- Sales CAGR >30%.
- Profit CAGR >20%.
- Revenue Impact >5%.


Return ONLY:

| Stock | Symbol | DateTime | Order Value | Client | Revenue Impact | Conviction |

If none exist, return:
NO NEW MATERIAL ORDER ANNOUNCEMENTS TODAY.
`;

    return encodeURIComponent(prompt);
};


export const tendersOrder = () => {
const prompt = `HIGH-CONVICTION GOVERNMENT TENDER → FUTURE ORDER WINNER STOCK SCREENER

TODAY: ${new Date().toISOString().slice(0,10)}

IMPORTANT:

Search ONLY for ACTIVE government tenders that are currently in progress.

DO NOT include:
- Any tender where Letter of Award (LOA) has already been issued.
- Any contract already awarded.
- Any order already announced on NSE/BSE.
- Any completed tender.
- Any historical news article.
- Any article about an already won project.
- Any order announced before today.
- Any company that has already disclosed winning the order.
- Any re-published or archived news.

Only include tenders where:
- Bid submission, technical evaluation, financial bid opening, L1 evaluation, or award decision is EXPECTED today.
- Winner has NOT yet been officially announced.
- Tender status is LIVE / OPEN / UNDER EVALUATION.
- Tender information is from official government procurement portals.

If a tender already has a declared winner, exclude it completely.

Strict Filters:
- Tender Value ≥ ₹500 Crore
- Revenue Impact > 5%
- Win Probability >90%
- Listed Indian Companies only
- Market Cap > ₹1000 Cr

Output only:

| NSE Symbol | Sector | Tender Value | Milestone Date | Current Tender Stage | Win Probability | Expected Order Value | Revenue Impact | Tender Authority | Conviction |

If no qualifying tenders exist today, return exactly:

NO HIGH-CONVICTION ACTIVE GOVERNMENT TENDERS TODAY
`;

    return encodeURIComponent(prompt);
};